import { useEffect } from 'react';
import { Link, useRouteError } from 'react-router';

import { NOT_FOUND } from 'shared/constants';

const ErrorPage = () => {
  const error = useRouteError();
  const isPageNotFound = error.status === NOT_FOUND;
  const errorMessage = isPageNotFound ? '404 Page Not Found' : 'Looks Like an Error 🧐';

  useEffect(() => {
    fetch('/error', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        error: {
          message: error.message || error.statusText,
          stack: error.stack || error.componentStack,
          status: error.status,
          url: window.location.href,
        },
      }),
    });
  }, [error]);

  return (
    <div className="container">
      <div className="page">
        <h2 className="error-title">{errorMessage}</h2>
        {!isPageNotFound && (<q className="error-message">{error.statusText || error.message}</q>)}
        <Link to="/" className="link error-back-link">Back to Home Page</Link>
      </div>
    </div>
  );
};

export default ErrorPage;
